import {ModuleConfiguration} from "../router/model/UserPermission";
import {
    ActionsServiceModuleName,
    ActionStatusModuleName,
    NgMessagesModule,
    OpportunityActionsModuleName
} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const OpportunityModule = new ModuleConfiguration(
    OpportunityActionsModuleName,
    [
        AngularJsMaterialModuleName,
        ActionsServiceModuleName,
        NgMessagesModule,
        ActionStatusModuleName
    ]);